import { defaultDevPanelFlag } from './devPanelAccess';

/** @type {Record<string, string | number | boolean>} */
export const REMOTE_CONFIG_DEFAULTS = {
  min_app_version: '0.1.40',
  // Mirror of platform.dev_panel defaults; UI gate uses platform flag + canHostDevPanel.
  feature_dev_panel: defaultDevPanelFlag(),
  feature_phone_auth: false,
  feature_ai_assist: true,
  feature_rag: true,
  feature_live_support: true,
  feature_audit_export: false,
  cutoff_warning_minutes: 5,
  maintenance_mode: false,
  rag_top_k: 5,
  // Normalized RRF floor (see functions/src/core/rag/rrf.ts normalizeRrfScore).
  rag_min_score: 0.08,
};
